import { Constants } from '@sukiai/components'
import {
  GET_AGENT_POSITION,
  GET_AGENT_SIZE,
  GET_AGENT_STATE
} from '../actions'
import loSto from '../../config/loSto'
import seshSto from '../../config/seshSto'
import { LO_STO, SESH_STO } from '../../lib'
const { AGENT } = Constants

const defaults = {
  agentSize: loSto.get(LO_STO.LAST_AGENT_SIZE) || AGENT.SIZE.LARGE,
  agentState: AGENT.STATE.MUTED,
  agentPosition: loSto.get(LO_STO.LAST_AGENT_POSITION) || AGENT.POSITION.MIDDLE_LEFT,
  dictation: false,
  s2EventsArray: []
}

const resolvers = {
  Mutation: {
    setAgentSize: (_, { agentSize }, { cache }) => {
      const last = cache.readQuery({ query: GET_AGENT_SIZE })
      loSto.set(LO_STO.LAST_AGENT_SIZE, last.agentSize)
      const data = { agentSize }
      cache.writeData({ data })
      return null
    },
    setAgentState: (_, { agentState }, { cache }) => {
      const disableAgent = seshSto.session(SESH_STO.DISABLE_AGENT)
      if (agentState !== 'MUTED' && disableAgent === 'true') {
        return null
      }

      const last = cache.readQuery({ query: GET_AGENT_STATE })
      seshSto.session(SESH_STO.LAST_AGENT_STATE, last.agentState)
      const data = { agentState }
      cache.writeData({ data })
      return null
    },
    setAgentPosition: (_, { agentPosition }, { cache }) => {
      const last = cache.readQuery({ query: GET_AGENT_POSITION })
      loSto.set(LO_STO.LAST_AGENT_POSITION, last.agentPosition)
      const data = { agentPosition }
      cache.writeData({ data })
      return null
    },
    setDictation: (_, { dictation }, { cache }) => {
      const data = { dictation }
      cache.writeData({ data })
      return null
    },
    setS2EventsArray: (_, { s2EventsArray }, { cache }) => {
      const data = { s2EventsArray }
      cache.writeData({ data })
      return null
    }
  }
}

export default {
  defaults,
  resolvers
}
